import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-restricted',
  templateUrl: './restricted.component.html',
  styleUrls: ['./restricted.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class RestrictedComponent implements OnInit {

  errorText = `Behörigheter saknas för sidan du försökte besöka.`; 
  constructor() { }

  ngOnInit() {
    console.log('restricted')
  }

}
